<template>
  <div>
    <heading>{{ $t("sidebar.environmentalReports") }}</heading>
    <dateFolderTable
      :rows="rows"
      :loading="loading"
      :nameLabel="$t('folders.year')"
      @open="openYear"
    />
  </div>
</template>

<script>
import dateFolderTable from "../../components/_utils/dateFolderTable.vue";

export default {
  name: "environmentalReportYears",
  components: { dateFolderTable },
  data: () => ({ counts: {}, loading: false }),
  async created() {
    this.loading = true;
    try {
      this.counts =
        (await this.$store.dispatch("getEnvironmentalReportYearCounts")) || {};
    } finally {
      this.loading = false;
    }
  },
  computed: {
    rows() {
      const present = Object.keys(this.counts)
        .map(Number)
        .filter((n) => !Number.isNaN(n));
      const currentYear = new Date().getFullYear();
      const min = Math.min(currentYear, ...present);
      const max = Math.max(currentYear, ...present);
      const rows = [];
      for (let y = max; y >= min; y--) {
        rows.push({
          key: String(y),
          label: String(y),
          total: (this.counts[String(y)] || {}).total || 0,
        });
      }
      return rows;
    },
  },
  methods: {
    openYear(row) {
      this.$router.push({
        name: "environmentalReportMonths",
        params: { year: row.key },
      });
    },
  },
};
</script>
